import { Moment } from 'moment'
import React, { FunctionComponent, MouseEvent } from 'react'

import { calendarWeeks } from '../CalendarToolbar/settings/calendarWeeks'

import {
  CalendarDropDownNext,
  CalendarDropDownNextContent,
  CalendarNextDateButton,
  CalendarNextIcon,
  CalendarSkipNextDateButton,
  CalendarSkipNextDateButtonWrapper,
  CalendarSkipNextIcon,
} from './style'

interface IProps {
  date: Moment
  amountOfDays: number
  onDateChanged: (date: Moment) => void
  windowWidth: number
}

export const CalendarToolbarNextButtons: FunctionComponent<IProps> = ({
  date,
  amountOfDays,
  onDateChanged,
  windowWidth,
}) => {
  const nextWeeksSkip = (e: MouseEvent<HTMLParagraphElement>) => {
    if (e.currentTarget.textContent) {
      const numberOfWeeks: string = e.currentTarget.textContent.split(' ')[0]
      onDateChanged(date.clone().add(numberOfWeeks, 'weeks'))
    }
  }

  const skipToNextWeek = () => {
    const today: Moment = date.clone()
    const nextMonday: Moment = today.add('days', amountOfDays)
    onDateChanged(nextMonday)
  }

  return (
    <>
      <CalendarNextDateButton onClick={skipToNextWeek}>
        <CalendarNextIcon icon="chevron-right" />
      </CalendarNextDateButton>

      <CalendarSkipNextDateButtonWrapper className="dropdown">
        <CalendarSkipNextDateButton windowWidth={windowWidth}>
          <CalendarSkipNextIcon icon="chevron-double-right" />
        </CalendarSkipNextDateButton>
        <CalendarDropDownNext className="dropdown-content">
          {calendarWeeks.map(weeks => (
            <CalendarDropDownNextContent key={weeks} onClick={nextWeeksSkip}>
              {weeks}
            </CalendarDropDownNextContent>
          ))}
        </CalendarDropDownNext>
      </CalendarSkipNextDateButtonWrapper>
    </>
  )
}
